export const STORAGE_KEY = {
  SELECT_BUSINESS: 'CSBusinessSelect',
  SIDEBAR: 'CSSidebar',
  EMAIL_NOT_VERIFY: 'CSEmailNotVerify',
} as const;

export const SESSION_KEY = {
  HAS_NAVIGATED: 'CSHasNavigated',
} as const;

export const IDS = {
  CONFIRM_FORM: 'confirm-form',
};

export const URL_QUERY = {
  ACCOUNT: 'account',
  FN_YEAR: 'fnYear',
  PERIOD: 'period',
};
